// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 50px;\n  margin-left: 10px;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614] {\n    color: #97a8be;\n    cursor: text;\n}\n", ""]);
// Exports
module.exports = exports;
